import React from 'react'
import RedirectUI, { getPathNewUi } from 'guards/RedirectUI'

export const BatchUploadApp = () => {
  const path = getPathNewUi('/platform/dataAssure/operational/supplierValidation')
  return <RedirectUI omitValidation={true} path={path} />
}
